// SystemFunction.js — re-export จาก SiteConfig (backward compatible)
// ไม่ต้องแก้ไฟล์นี้ — แก้ที่ SiteConfig.js แทน
import SiteConfig from './SiteConfig'
const Systems = SiteConfig.System
export default Systems
